<template>
  <div id="app">
    <AppTopMenu v-if="topPartType == 0"  />
    <app-top-part v-else v-bind:white-item="currentItem" />
    <router-view v-wechat-title="$route.meta.title" />
    <div id="app_bottom">
      <div>{{company + "版权所有"}} </div>
      <div>{{"联系地址：" + address}}</div>
      <div>{{'联系电话：' + tel}}</div>
      <div>
        <a target="_blank" style="color: inherit;" href="https://beian.miit.gov.cn/#/Integrated/index">{{registerCode}}</a>
        {{bottomRemark}}
      </div>
    </div>

  </div>
</template>

<script>
import AppTopMenu from "./components/AppTopMenu";
import AppTopPart from "./components/AppTopPart";
export default {
  name: 'App',
  components: {AppTopPart, AppTopMenu},
  props: {
    AppTopMenu,
    AppTopPart
  },
  data() {
    //联系地址：上海市浦东新区泳耀路300号东方体育大厦8楼806室     联系电话：021-64375854
    return {
      company: '上海市篮球协会',
      address: '上海市浦东新区泳耀路300号东方体育大厦8楼806室',
      tel: '18116496980',
      // registerCode: '沪ICP备2022001212号',
      registerCode: '沪ICP备2022001212号',
    }
  },
  mounted() {
    if (this.topPartType == 1) {
      this.testAppIdObject.alreadyRegister = true;
      this.configShareWx(encodeURIComponent(location.href), this.$store.state.http.defaultShareObj);
    }
    let banners = this.dataManager.getBanners();
    if (banners == null) {
      this.loadBanners();
    } else {
      this.$store.commit('setBanners', banners);
    }
  },
  computed: {
    bottomRemark() {
      // this.registerCode +
      return "  COPYRIGHT 2014-" + (new Date()).getFullYear() + "SHSLAXH.ORG.RIGHTS RESERVED";
    },

    dataManager() {
      return this.$store.state.dataStore;
    },

    whiteList () {
      return this.$store.state.whiteList;
    },
    topPartType() {
      let item = this.currentItem;
      if (item == null) {
        return 0
      }
      return 1;
    },

    currentItem() {
      let defaultList = this.whiteList;
      let path = this.$route.path;
      if (defaultList.length == 0) {
        return null;
      }

      for (var i = 0; i < defaultList.length; i++) {
        let item = defaultList[i];
        if (path.indexOf(item.path) != -1) {
          return item;
        }
      }
      return null;
    },
  },
  methods: {

    loadBanners() {
      let _this = this;
      this.$store.state.http.ajax.vmAllTagBanners(function (data) {
        console.log(data);
        let code = data.code;
        if (code == 0) {
          let banners = data.data;
          _this.dataManager.setBanners(banners);
          _this.$store.commit('setBanners', banners);
        }
      }, function (data) {

      });
    }
  }
}
</script>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#app_bottom {
  background-color: #393939;
  padding-top: 2.17rem;
  padding-bottom: 1.56rem;
  text-align: center;
  width: 100vw;

}
  #app_bottom div {
    color: white;
    font-size: 0.75rem;
    font-weight: bold;
    margin-top: 0.89rem;
  }

  #app_bottom div:first-child {
    font-size: 1rem;
    font-weight: normal;
    margin-top: 0rem;
  }

  #app /deep/ .el-loading-spinner .path {
    stroke: #fc1a34;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue